import { useMemo } from "react";
import COMPONENTS from "./components";

export default function useComponents(components) {
  return useMemo(() => ({ ...COMPONENTS, ...components }), [components]);
}
